import { Button } from '@repo/shadcn';
import { useNavigate } from 'react-router-dom';

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again later.';

type SectionErrorProps = {
    error: unknown;
    fallbackPath?: string;
};

export const SectionError = ({
    error,
    fallbackPath = '/',
}: SectionErrorProps) => {
    const navigate = useNavigate();
    let errorMessage = DEFAULT_ERROR_MESSAGE;

    if (error instanceof Error) {
        errorMessage = error.message;
    }

    if (typeof error === 'object' && error !== null && 'data' in error) {
        const data = error.data;
        if (data && typeof data === 'object' && 'message' in data) {
            errorMessage = data.message as string;
        }
    }

    return (
        <div className="flex flex-col items-center justify-center rounded-md border border-orange-500 bg-orange-50 p-4 px-4 py-8 text-orange-500">
            <p>{errorMessage}</p>
            <Button
                variant="outline"
                className="mt-4"
                onClick={() => navigate(fallbackPath)}
                type="button"
            >
                Go Back
            </Button>
        </div>
    );
};

SectionError.displayName = 'SectionError';
